import { db } from "../firebase/firebase";
import { apiUrl, currentTimeAndDate, setFetchHeaders } from "../variables";
export const awsApiUrl =
  "https://us-central1-alphatuos.cloudfunctions.net/awsDjango";

export const createAnalysis = async (token, documentId, data) => {
  // console.log(data, "DATAAAA");
  try {
    const resp = await fetch(`${apiUrl}/documents/${documentId}/analysis`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: setFetchHeaders(token),
    });
    // console.log(resp);
    const serverResp = await resp.json();
    // console.log("PATCH, serverResp :>>", serverResp);
    return serverResp;
  } catch (error) {
    console.log("error from creating analysis function", error.message);
    throw Error(error.message);
  }
};

export const updateAnalysis = async (token, documentId, analysisId, data) => {
  try {
    const resp = await fetch(
      `${apiUrl}/documents/${documentId}/analysis/${analysisId}`,
      {
        method: "PATCH",
        body: JSON.stringify(data),
        headers: setFetchHeaders(token),
      }
    );
    // console.log(resp);
    const serverResp = await resp.json();
    // console.log("PATCH, serverResp :>>", serverResp);
    return serverResp;
  } catch (error) {
    console.log("error from updating analysis function", error.message);
    throw Error(error.message);
  }
};

export const deleteAnalysis = async (token, documentId, analysisId) => {
  try {
    const resp = await fetch(
      `${apiUrl}/documents/${documentId}/analysis/${analysisId}`,
      {
        method: "DELETE",
        headers: setFetchHeaders(token),
      }
    );
    const serverResp = await resp.json();

    return serverResp;
  } catch (error) {
    console.log("error from deleting analysis function", error.message);
    throw Error(error.message);
  }
};

export const getAnalysis = async (documentId) => {
  const snapshots = await db
    .collection("Documents")
    .doc(documentId)
    .collection("Analysis")
    .get();
  const output = [];
  if (!snapshots.empty) {
    snapshots.forEach((snap) => {
      const data = snap.data();
      output.push({
        id: snap.id,
        data: { ...data, dateTime: currentTimeAndDate(data.dateTime.toDate()) },
      });
    });
  }

  return output;
};

//return array of Strings
export const getStringValues = (data, col) => {
  let value = [];

  data.forEach((dat, index) => {
    if (
      Object.keys(dat).length > 0 &&
      dat[col] !== undefined &&
      index !== 0 &&
      dat[col] !== ""
    ) {
      value.push(dat[col]);
    }
  });

  return value;
};

//return array of Strings
export const getHeaders = (data, col) => {
  let value = [];

  data.forEach((dat, index) => {
    if (Object.keys(dat).length > 0 && dat[col] !== undefined && index === 0) {
      value.push(dat[col]);
    }
  });

  return value;
};

//return first property as String
export const getStringFirst = (data, col) => {
  let value = [];

  data.forEach((dat, index) => {
    if (Object.keys(dat).length > 0 && dat[col] !== undefined) {
      if (index === 0) {
        value.push(dat[col]);
      } else {
        value.push(Number(dat[col]));
      }
    }
  });

  return value;
};

export const arrangeStringFirst = (first, second) => {
  let final = [];
  first.forEach((a1, index) => {
    final.push([first[index], second[index]]);
  });

  return final;
};

export const formatOutput = (output) => {
  if (
    (output < 0.0001 && output > 0) ||
    (output > -0.0001 && output < 0) ||
    output >= 1000000000 ||
    output <= -1000000000
  ) {
    return output.toExponential(4);
  } else {
    return output.toFixed(4);
  }
};
